import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IOverDueTasksState } from './type';
const initialState: IOverDueTasksState = {
  overdueTasks: {},
};
const slice = createSlice({
  name: 'overdueTasks',
  initialState,
  reducers: {
    getOverdueTasks(state, action: PayloadAction<{ userId: number }>) {
      state.overdueTasks.status = RequestStatus.RUNNING;
    },
    getOverdueTasksSuccess(
      state,
      action: PayloadAction<IOverDueTasksState['overdueTasks']['data']>
    ) {
      state.overdueTasks.status = RequestStatus.SUCCESS;
      state.overdueTasks.data = action.payload;
    },
    getOverdueTasksFailed(state, action: PayloadAction<IRequestFailed>) {
      state.overdueTasks.status = RequestStatus.ERROR;
      state.overdueTasks.error = action.payload;
    },
  },
});
export default slice.reducer;
export const { getOverdueTasks, getOverdueTasksFailed, getOverdueTasksSuccess } = slice.actions;
